
import { Component, Vue } from 'vue-property-decorator';
import TagRepositoryInterface, { TagInterface } from '../../../../services/QA/tag/interfaces';
import { WPXFormValue } from '@/components/templates/WPXForm';
import { CreateTagForm } from '@/services/QA/tag/forms/CreateTagForm';

@Component({
  inject: [
    'tagRepository',
  ],
})
export default class CreateTag extends Vue {
  private readonly tagRepository!: TagRepositoryInterface;
  private loading: boolean = true;
  private form: WPXFormValue<CreateTagForm> = new WPXFormValue(CreateTagForm);

  public created(): void {
    this.loading = false;
  }

  private async createTag(): Promise<void> {
    try {
      await this.tagRepository.createTag({
        label: this.form.data.label,
        color: this.form.data.color,
      });

      this.$successDialog.show(`Tag '${this.form.data.label}' has been created`);
      await this.$router.push({ path: '/qc-settings/tags' });
    } catch (err) {
      this.$errorDialog.show(err.response.data.message);
    }
  }
}
